import { Component, OnInit, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-show-errors',
  templateUrl: './show-errors.component.html',
  styleUrls: ['./show-errors.component.css']
})
export class ShowErrorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  private static readonly errorMessages = {
    'required': () => 'campo obbligatorio',
    'minlength': (params) => 'il numero minimo di caratteri è ' + params.requiredLength,
    'maxlength': (params) => 'il numero massimo di caratteri è ' + params.requiredLength,
    'pattern': (params) => 'il pattern richiesto è ' + params.requiredPattern,
    'years': (params) => params.message,
    'countryCity': (params) => params.message,
    'uniqueName': (params) => params.message,
    'telephoneNumbers': (params) => params.message,
    'telephoneNumber': (params) => params.message,
    'catalogazione': (params) => params.message,
    'contributor': (params) => params.message,
    'ean13': (params) => params.message,
    'dewey': (params) => params.message,
    'related-product': (params) => params.message,
    'lingua': (params) => params.message,
    'argomento': (params) => params.message,
    'audience': (params) => params.message,
    'stagionalita': (params) => params.message,
    'catalog': (params) => params.message,
    'servstampa': (params) => params.message

  };

  @Input()
  private control: AbstractControlDirective | AbstractControl;

  @Input()
  private shouldBeDirty: boolean = true;

  shouldShowErrors(): boolean {
    return this.control &&
      this.control.errors
      && (this.shouldBeDirty ? (this.control.dirty || this.control.touched) : true);
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    return ShowErrorsComponent.errorMessages[type](params);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/show-errors/show-errors.component.ts